export const logEvent = (name, parameters) => {
  window.gtag('event', name, parameters)
}
